module.exports = __webpack_public_path__ + "static/media/p1.f3162048.svg";